interface ContentfulImage {
	_id: String;
	url: String;
	contentType: String;
	dimensions: {
		height: Number;
		width: Number;
	};
	size: Number;
	title: String;
}

/**
 * Contentful returns images and media as an objec type with
 * various properties, including a URL.
 * The URL has no protocol - e.g. //something.foo.bar/path/name/file.jpg
 *
 * In order to make this friendly for Image components in RN, we need to prepend a
 * protocol and enwrap in an object with a uri parameter
 *
 * Accepts a fallback if the image is empty.
 *
 * @param {ContentfulImage} image
 * @param {any} fallback
 * @returns {uri: String}
 */
export default function (image: ContentfulImage, fallback?: any) {
	if (!image) {
		return fallback || null;
	}
	const { url } = image;
	return { uri: `https:${url}` };
}
